import { createContext, useContext, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

const ThemeContext = createContext(null);

const applyTheme = (theme, accent) => {
  const root = document.documentElement;
  const t = theme || "oled";
  root.setAttribute("data-theme", t);
  if (accent) {
    root.style.setProperty("--brand", accent);
    // compute a slightly darker hover by hex shift
    root.style.setProperty("--brand-hover", accent);
    // update tailwind primary hsl to a close approximation (keep OLED default green for UI)
  }
};

export const ThemeProvider = ({ children }) => {
  const { user, updateUser } = useAuth();

  useEffect(() => {
    const theme = user?.theme || localStorage.getItem("stb_theme") || "oled";
    const accent = user?.accent_color || localStorage.getItem("stb_accent") || "#00FF66";
    applyTheme(theme, accent);
  }, [user?.theme, user?.accent_color]);

  const setTheme = async (theme) => {
    localStorage.setItem("stb_theme", theme);
    applyTheme(theme, user?.accent_color || "#00FF66");
    if (user) await updateUser({ theme });
  };

  const setAccent = async (accent_color) => {
    localStorage.setItem("stb_accent", accent_color);
    applyTheme(user?.theme || "oled", accent_color);
    if (user) await updateUser({ accent_color });
  };

  return (
    <ThemeContext.Provider value={{
      theme: user?.theme || "oled",
      accent: user?.accent_color || "#00FF66",
      setTheme,
      setAccent,
    }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
};
